import { format, subDays } from 'date-fns';

export type ConcertDateMode = 'upcoming' | 'past';

type ConcertDateFilters = { date_after: string | undefined; date_before: string | undefined };

/** The `yyyy-MM-dd` the concert date filters speak, read in the user's own timezone. */
function dateParam(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

/**
 * Upcoming starts at today: concert dates are stored at UTC midnight and `date_after` is an
 * inclusive `$gte`, so a concert happening today is upcoming.
 */
export function upcomingDateAfter(): string {
  return dateParam(new Date());
}

/** Past stops the day before today, so today belongs to "upcoming" alone. */
export function pastDateBefore(): string {
  return dateParam(subDays(new Date(), 1));
}

export function upcomingDateFilters(): ConcertDateFilters {
  return { date_after: upcomingDateAfter(), date_before: undefined };
}

export function pastDateFilters(): ConcertDateFilters {
  return { date_after: undefined, date_before: pastDateBefore() };
}

export const CLEARED_DATE_FILTERS: ConcertDateFilters = { date_after: undefined, date_before: undefined };

/**
 * Which shortcut, if any, the current range spells out. There is no mode stored anywhere: the
 * buttons only write `date_after`/`date_before`, so saved views keep working untouched.
 */
export function concertDateMode(
  dateAfter: string | undefined,
  dateBefore: string | undefined,
): ConcertDateMode | null {
  if (!dateBefore && dateAfter === upcomingDateAfter()) return 'upcoming';
  if (!dateAfter && dateBefore === pastDateBefore()) return 'past';
  return null;
}
